import { InventoryCountry } from './inventoryCountry';

export class InventoryState {
    id: string;
    name: string;
    country: InventoryCountry = new InventoryCountry();
}